
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/level-2-electrical-services-asp-accredited-sydney",
      function () {
        return require("private-next-pages/services/level-2-electrical-services-asp-accredited-sydney/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/level-2-electrical-services-asp-accredited-sydney"])
      });
    }
  